/** Narrow-screen replacement for the nav rail. */
export function ApiJumpSelect({ groups, activeId, onSelect }) {
  return (
    <div className="apiJump">
      <label className="apiMeta" htmlFor="apiJumpSelect">Jump to resource</label>
      <select
        id="apiJumpSelect"
        className="apiJumpSelect"
        value={activeId || ""}
        onChange={(e) => onSelect(e.target.value)}
      >
        {groups.map((group) => (
          <optgroup label={group.label} key={group.id}>
            {group.resources.map((r) => (
              <option value={r.id} key={r.id}>{r.label}</option>
            ))}
          </optgroup>
        ))}
        <optgroup label="Reference">
          <option value="grammar">Filter grammar</option>
          <option value="types">Data types</option>
          <option value="errors">Errors</option>
        </optgroup>
      </select>
    </div>
  );
}
